// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"3097":"6c2345d8","5615":"9bd65c6f"}[chunkId] + ".chunk.css";
};